var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改场地" : "添加场地",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "110px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "location_name", label: "场地名称" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: {
                  disabled: "",
                  autocomplete: "off",
                  placeholder: "请选择地址"
                },
                model: {
                  value: _vm.formData.location_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "location_name", $$v)
                  },
                  expression: "formData.location_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { label: "场地logo", prop: "location_img" }
            },
            [
              _c("uploadImage", {
                attrs: { value: _vm.imgList },
                on: { input: _vm.imgChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "location", label: "场地地址" }
            },
            [
              _c("el-autocomplete", {
                staticClass: "flex-1",
                staticStyle: { width: "100%" },
                attrs: {
                  "fetch-suggestions": _vm.querySearchAsync,
                  placeholder: "请输入关键词搜索地址",
                  clearable: ""
                },
                on: { select: _vm.handleSelect },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "addr",
                            staticStyle: {
                              "font-size": "12px",
                              color: "#b4b4b4"
                            }
                          },
                          [_vm._v(_vm._s(item.address))]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.formData.location,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "location", $$v)
                  },
                  expression: "formData.location"
                }
              })
            ],
            1
          ),
          _c("div", {
            staticStyle: {
              width: "100%",
              height: "250px",
              "margin-bottom": "20px",
              "border-radius": "4px",
              border: "1px solid #ddd"
            },
            attrs: { id: "map-container" }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }